<template>
  <VcSelect
    v-model="model"
    :name="formElement.key"
    text-field="caption"
    value-field="value"
    :items="formElement.properties.items"
    :label="formElement.properties.label"
    :placeholder="formElement.properties.placeHolder"
    class="w-full"
    :required="isRequired"
    :disabled="!formElement.properties.items.length"
    :message="message"
    :error="error"
    size="md"
    autocomplete
    @change="(newValue) => validate(newValue)"
  >
    <template #placeholder>
      <div class="flex h-[50px] items-center gap-3 px-5 py-3.5 text-base">
        <input type="hidden" :name="formElement.key" />
        {{ formElement.properties.placeHolder }}
      </div>
    </template>

    <template #selected="{ item }">
      <div class="flex h-[50px] items-center gap-3 rounded-md px-5 py-3 text-base">
        <input v-model="item.value" type="hidden" :name="formElement.key" />
        {{ item.caption }}
      </div>
    </template>

    <template #item="{ item }">
      {{ item.caption }}
    </template>
  </VcSelect>
</template>

<script lang="ts" setup>
import { computed, onBeforeMount, ref } from "vue";
import { FormValidator } from "../forms-sdk";
import type { ElementValidationResult } from "../forms-sdk";
import type { ExtendedFormElement } from "../types";

interface IProps {
  formElement: ExtendedFormElement;
  errorMessage?: ElementValidationResult;
}

interface IEmits {
  (event: "update:error-message", error: ElementValidationResult): void;
}
const emit = defineEmits<IEmits>();

const props = defineProps<IProps>();
const model = defineModel<string>();
const elementValidationResult = ref<ElementValidationResult>({ valid: true, message: "" });
const message = computed(() => elementValidationResult.value?.message || props.errorMessage?.message);
const error = computed(() => !!elementValidationResult.value?.message || !!props.errorMessage?.message);

onBeforeMount(() => {
  model.value = props.formElement.properties.items.find((item) => item.checked)?.value;
});

const isRequired = computed(
  () => !!props.formElement.properties.validators.find((v) => v.type === "RequiredValidator"),
);

const formValidator = new FormValidator(props.formElement);

function validate(newValue: string): void {
  elementValidationResult.value = formValidator.validate(newValue);
  emit("update:error-message", elementValidationResult.value);
}
</script>
